import { render, staticRenderFns } from "./BookingMiniature.vue?vue&type=template&id=c45011dc&scoped=true&"
import script from "./BookingMiniature.vue?vue&type=script&lang=js&"
export * from "./BookingMiniature.vue?vue&type=script&lang=js&"
import style0 from "./BookingMiniature.vue?vue&type=style&index=0&id=c45011dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45011dc",
  null
  
)

export default component.exports